export const BASE_URL = 'https://myb-travels-server.vercel.app';